import React from 'react';
import FileLink from '../../shared/FileLink';
import { useResolvedFileUrl } from '../../shared/useResolvedFileUrl';
import './multi-modal-content.scss';

interface ImageContentProps {
  imageUrl: string;
  alt?: string;
  className?: string;
}

const ImageContent: React.FC<ImageContentProps> = ({
  imageUrl,
  alt = 'Message attachment',
  className = '',
}) => {
  const resolved = useResolvedFileUrl(imageUrl);

  if (resolved.status === 'failed' || resolved.status === 'private') {
    return (
      <div className={`image-content image-content-unavailable ${className}`}>
        Image unavailable
      </div>
    );
  }
  if (resolved.status === 'loading') return null;

  return (
    <div className={`image-content ${className}`}>
      <FileLink url={imageUrl} className='image-link'>
        <img src={resolved.src} alt={alt} className='message-image' />
      </FileLink>
    </div>
  );
};

export default ImageContent;
